export default {
    props: {
        addressData :  {
            type    : Object,
            default: () => {}
        },
        addressTitle :  {
            type    : String,
            default : 'Title'
        },
        noAddressData :  {
            type    : Boolean,
            default : false
        },
        noAddressDataText : {
            type    : String,
            default : 'Title'
        },
    },
    data: () => ({
    }),
    methods : {
        onBtnEditAddressClcik() {
            console.info('onBtnEditAddressClcik: address card');
            this.$emit('btn-edit-address-click');
        }
    },
    watch: {
        addressTitle(value) {
            this.addressTitle = value;
        },
        noAddressDataText(value) {
            this.noAddressDataText = value;
        },
    }
};
